import {useCallback, useEffect, useState} from "react";


export const getOnLineStatusFromNavigator = () => {
    return (typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean'
        ? navigator.onLine
        : true);
};

const useOnlineStatus = () => {

    // ONLINE STATUS - use this hook to get at it
    // e.g.
    //        const { isOnline } = useOnlineStatus();
    //
    const [isOnline, setOnline] = useState(true);

    const updateOnlineStatus = useCallback(() => {
        setOnline(getOnLineStatusFromNavigator());
    }, []);

    // Call manually on first load in case browser does not fire load event
    useEffect(() => {
        updateOnlineStatus();
    }, [updateOnlineStatus]);

    // Online/Offline event listeners to detect online status changes
    useEffect(() => {
        window.addEventListener("load", updateOnlineStatus);
        window.addEventListener("online", updateOnlineStatus);
        window.addEventListener("offline", updateOnlineStatus);

        return () => {
            window.removeEventListener("load", updateOnlineStatus);
            window.removeEventListener("online", updateOnlineStatus);
            window.removeEventListener("offline", updateOnlineStatus);
        };
    }, [updateOnlineStatus]);

    return { isOnline };
};

export default useOnlineStatus;
